import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { catchError, map, Observable, of, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CounterResultAdapter {
  constructor(
    private http: HttpClient,
    private occEndPointService: OccEndpointsService,
  ) {}

  headContent(query: string): Observable<number> {
    const params: { [key: string]: string } = {};
    params['query'] = query;

    const url = this.occEndPointService.buildUrl('contentSearch', { queryParams: params });

    return this.http.head(url, { observe: 'response' }).pipe(
      take(1),
      map((data: any) => data?.headers?.get('x-total-count') || 0),
      catchError(() => {
        return of(0);
      }),
    );
  }

  headProduct(query: string): Observable<number> {
    const params: { [key: string]: string } = {};
    params['query'] = query;

    const url = this.occEndPointService.buildUrl('productSearch', { queryParams: params });

    return this.http.head(url, { observe: 'response' }).pipe(
      take(1),
      map((data: any) => data?.headers?.get('x-total-count') || 0),
      catchError(() => {
        return of(0);
      }),
    );
  }

  headLiterature(query: string): Observable<number> {
    const params: { [key: string]: string } = {};
    params['query'] = query;

    const url = this.occEndPointService.buildUrl('literatureSearch', { queryParams: params });

    return this.http.head(url, { observe: 'response' }).pipe(
      take(1),
      map((data: any) => data?.headers?.get('x-total-count') || 0),
      catchError(() => {
        return of(0);
      }),
    );
  }
}
